import React, { Component } from 'react';
// import queryString from 'query-string';
import { observer, inject } from 'mobx-react';
// import { keyframes } from 'styled-components';
// import styled from 'styled-components';
// import logo from './logo.svg';
import { Button, Row, Col, Form, Input, Icon, DatePicker, Checkbox, Select } from 'antd';
import bg from './bg.svg';
import bg2 from './bg2.png';
import logo123 from './logo123.png';
import './App.css';
import { createForm, FormItem, setInternalFormItem } from 'rc-mobx-form'
import Geosuggest from 'react-geosuggest';
import moment from 'moment';
import * as mobx from 'mobx';
import isMobile from './utils/isMobile.js'
import strings from './utils/strings.js'
import DateTimePicker from 'react-mobile-datetimepicker';

const Option = Select.Option;


// if you use ant-design
setInternalFormItem(Form.Item)
const CheckboxGroup = Checkbox.Group;

// keyframes returns a unique name based on a hash of the contents of the keyframes
// const rotate360 = keyframes`
//   from {
//     transform: rotate(0deg);
//   }
//   to {
//     transform: rotate(360deg);
//   }
// `;
let fareSelected = false;

// Here we create a component that will rotate everything we pass in over two seconds


@inject('routing', 'appState', 'userState')
@observer
class App extends Component {
  constructor(props) {
    super(props);
    console.log('localStorage', localStorage);
    this.state = {
        width: '0',
        height: '0',
        titleForm: 'ĐẶT XE TRỰC TUYẾN',
        step: 1,
        timeString: moment().add(60*5, 'second').format('YYYY-MM-DD hh:mm'),
        time: new Date(),
        isOpen: false,
       };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    var lang = navigator.language || navigator.userLanguage; //no ?s necessary
    
    console.log('ss', strings.getLanguage(), lang);
    strings.setLanguage('vi');
    console.log('ss', strings.getLanguage());
    this.props.userState.setUserState('step', 1);
    this.updateWindowDimensions();
    
    if(!(isMobile.iOS()|| isMobile.Android())){
      window.addEventListener('resize', this.updateWindowDimensions);      
    }
  }
  
  componentWillUnmount() {
    if(!(isMobile.iOS()|| isMobile.Android())){
      window.addEventListener('resize', this.updateWindowDimensions);      
    }
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  onSuggestSelectFrom = (suggest) => {
    this.props.appState.setAppState('start',{ address: suggest.label, lat: suggest.location.lat, lng:suggest.location.lng })
    if (this.props.appState.start.lat !== 0 && this.props.appState.end.lat){
      this.props.appState.CaculateDistance(mobx.toJS(this.props.appState.start), mobx.toJS(this.props.appState.end));      
    }
    console.log(suggest); // eslint-disable-line
  }
  onSuggestSelectTo = (suggest) => {
    this.props.appState.setAppState('end',{ address: suggest.label, lat: suggest.location.lat, lng:suggest.location.lng })
    if (this.props.appState.start.lat !== 0 && this.props.appState.end.lat){
      this.props.appState.CaculateDistance(mobx.toJS(this.props.appState.start), mobx.toJS(this.props.appState.end));      
    }
  }
  handleSubmit = (e) => {
    console.log('fdsdf', );
    e.preventDefault();
    this.props.form.validateFields(fields => console.log('error', fields))
        .then((values) => {
          console.log('success', values, values[Object.keys(values)[0]])
          this.props.appState.setAppState('phone',values.phone)
          this.props.appState.setAppState('name',values.name)
          if (this.props.appState.start.lat !== 0 && this.props.appState.end.lat !== 0 ){
           const tmp = this.props.appState.getServiceGroup(this.props.appState.start, this.props.appState.end);
           console.log('tmp', tmp);
           this.props.appState.setAppState('price',0);
           this.props.userState.nextStep();
          }
        })
  }
  
  onOk = (value) => {
    // chu y : - booking_time_range_width
    this.props.appState.setAppState('time',value.unix())
  }
  onChangeCheckBox = (checkedValues) =>{
    const { serviceGroup } = this.props.appState;
    if(checkedValues.length === 1) {
      // this.setState({checkData: checkedValues});
      this.props.appState.setAppState('checkData', checkedValues);
      const tmp = checkedValues[0].split('_');
      fareSelected = mobx.toJS(serviceGroup[tmp[0]].fare_profile_lines[tmp[1]]);
      this.checkPrice(mobx.toJS(serviceGroup[tmp[0]].fare_profile_lines[tmp[1]]))
    } else if (checkedValues.length === 2) {
      let tmp = [];
      tmp.push(checkedValues[1]);
     // this.setState({checkData: tmp});
      this.props.appState.setAppState('checkData', tmp);      
      const tmp2 = checkedValues[1].split('_');
      fareSelected = mobx.toJS(serviceGroup[tmp2[0]].fare_profile_lines[tmp2[1]]);      
      this.checkPrice(mobx.toJS(serviceGroup[tmp2[0]].fare_profile_lines[tmp2[1]]))
    }
    console.log('checkedValues', checkedValues);
  }

  checkPrice = (fare) => {
    console.log('fare', fare);
    const distance = this.props.appState.distance;
    const duration =  this.props.appState.duration;
    const fare_id = fare.fpid; 
    const fromArea = fare.pickup_id;
    const isReturn = false;
    const pickup_time = this.props.appState.time;
    const return_distance = 0;
    const return_duration = 0; 
    const return_time = 0;
    const route = [{
      'arrive_time':{
      'end_time':0,
      'start_time':0
      },
      'location':{
      'address':this.props.appState.start.address,
      'area':'',
      'compact_address':'',
      'lat':this.props.appState.start.lat,
      'lng':this.props.appState.start.lng
      },
      'request_id':0,
      'stop_type':1
      },{
        'arrive_time':{
        'end_time':0,
        'start_time':0
        },
        'location':{
        'address':this.props.appState.end.address,
        'area':'',
        'compact_address':'',
        'lat':this.props.appState.end.lat,
        'lng':this.props.appState.end.lng
        },
        'request_id':0,
        'stop_type':2
        }];
    const serviceGroup = fare.service_group_id;
    const suplier_id = 0;
    const toArea = fare.dropoff_id;
    const vehicle_capacity = fare.vehicle_capacity;
    const vehicle_quality = fare.vehicle_class;
    const vehicle_type = fare.vehicle_type;

    const zz = JSON.stringify({
      distance, duration, fare_id, fromArea, isReturn, pickup_time, return_distance, return_duration, return_time, route, serviceGroup, suplier_id, toArea, vehicle_capacity, vehicle_quality, vehicle_type
    });
    console.log('zz', zz);
    this.props.appState.checkPrice(distance, duration, fare_id, fromArea, isReturn, pickup_time, return_distance, return_duration, return_time, route, serviceGroup, suplier_id, toArea, vehicle_capacity, vehicle_quality, vehicle_type)
  }

    // phone form submission handler
    smsLogin = () => {
      //var countryCode = document.getElementById("country_code").value;
      //var phoneNumber = document.getElementById("phone_number").value;
      window.AccountKit.login(
        'PHONE', 
        {countryCode: '+84', phoneNumber: this.props.appState.phone}, // will use default values if not specified
        this.loginCallback
      );
    }
  
    // email form submission handler
    emailLogin = () => {
      //var emailAddress = document.getElementById("email").value;
      window.AccountKit.login(
        'EMAIL',
        {emailAddress: ''},
        this.loginCallback
      );
    }
    
    fetchUserData = (url) => {
      fetch(url, {
        method: 'GET'
        })
        .then((response) => {
          console.log('responseresponse:', response);
          if (!response.ok) throw new Error(response.statusText)
          return response.json()
        })
        .then((resp) => {
          this.setState({isSuccessfulLogin:true,token:resp.access_token,userId:resp.id});
        })
        .catch((error) => {
          //console.error(error)
        })
    }
    
    // login callback
    loginCallback = (response) => {
      console.log('response',response );
      if (response.status === 'PARTIALLY_AUTHENTICATED') {
        this.props.appState.setAppState('accessToken',response.code);
        console.log('response.code', response.code);
        this.props.userState.getUserInfo(this.props.appState.phone, response.code, '', Object.assign({}, this.props.appState)).then((response)=>{
          console.log('xxxx', response);
        });

        // this.props.appState.setAppState('phone','0');
        // this.props.appState.removeData('');       

        // const code = response.code;
        // const account_kit_api_version = 'v1.1';
        // const app_id = '443768522489207';
        // const app_secret = '194af4ca53d1eb941c1634f1693e1126';
        // const token_exchange_base_url = `https://graph.accountkit.com/${account_kit_api_version}/access_token`;
  
        // const app_access_token = ['AA', app_id, app_secret].join('|');
        // const params = {
        //   grant_type: 'authorization_code',
        //   code,
        //   access_token: app_access_token
        // };
  
        // function toQueryString(paramsObject) {
        //   return Object
        //     .keys(paramsObject)
        //     .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`)
        //     .join('&')
        //   ;
        // }
  
        // const token_exchange_url = token_exchange_base_url + '?' + toQueryString(params);
        // this.fetchUserData(token_exchange_url);
      }
      else if (response.status === 'NOT_AUTHENTICATED') {
        // handle authentication failure
        
      }
      else if (response.status === 'BAD_PARAMS') {
        // handle bad parameters
        
      }
    }

  handleChangeLanguage = (value) =>{
    strings.setLanguage(value);
    this.forceUpdate();
  }

  onTimeChangeHandler = (value) => {
   
    
   this.setState({timeString: value});
  

  }

  handleClick = () => {
		this.setState({ isOpen: true });
	}

	handleCancel = () => {
		this.setState({ isOpen: false });
	}

	handleSelect = (time) => {
    this.setState({timeString: moment(time).format('YYYY-MM-DD hh:mm')})
    this.props.appState.setAppState('time',moment(time).unix())
		this.setState({ isOpen: false });
	}
  

  render() {
    const { getFieldProps } = this.props.form;
    const { serviceGroup } = this.props.appState;
    let tmpTabItem = [];
    if(serviceGroup.length !== 0){
      for(var i = 0 ; i< serviceGroup.length; i ++){
        let plainOptions = [];
        for(var j=0; j< serviceGroup[i].fare_profile_lines.length ; j++){
          plainOptions.push(<Col span={8}><Checkbox value={`${i}_${j}`}>{serviceGroup[i].fare_profile_lines[j].name}</Checkbox></Col>)
        }
        tmpTabItem.push(<Row style={{textAlign: 'left', color: 'white'}}> 
            <Col span={24} style={{ color: '#EF8A3E', fontWeight: 'bold'}}>
              *{serviceGroup[i].name}
            </Col>
            <br />
            <Col span={24}>
              {plainOptions}
            </Col>
            <br />
            <br />
            
          </Row>)
      }
    }
    let timeTag = <FormItem label={strings.time}>
    <Button className="ant-input ant-input-lg" style={{textAlign: 'left'}} onClick={this.handleClick} ><Icon type="calendar" />{this.state.timeString}</Button>

    <DateTimePicker
      value={this.state.time}
      isOpen={this.state.isOpen}
      onSelect={this.handleSelect}
      onCancel={this.handleCancel}
      dateFormat={['YYYY', 'MM','DD','h','m']}
      confirmTxt={strings.confirmTimeTxt}
      cancelTxt={strings.cancelTimeTxt} />
  </FormItem>
    if(!(isMobile.iOS()|| isMobile.Android())){
      timeTag =   <FormItem label={strings.time}>
      <DatePicker
        showTime
        defaultValue={moment().add(60*5, 'second')}
        format="YYYY-MM-DD HH:mm"
        placeholder={strings.enterTime}
        onChange={this.onChange}
        onOk={this.onOk}
        locale='vi'
        style={{width: '100%'}}
      />
    </FormItem>
    }

    return (
      <div className="App" style = {{backgroundImage: `url(${bg})`,backgroundSize:'cover', height: this.state.height > this.state.width ? this.state.height + 120 : 1000}} >
         <Row> 
            <img src={logo123} style={{width: this.state.width /3, marginTop: '40px'}} alt="" />
         </Row>
         <Row>
            <h3 style={{color:'white', marginTop:'5px'}}> {strings.title}
            </h3>
         </Row>

         <div style = {{backgroundImage: `url(${bg2})`, margin:'10px', padding:'10px'}} >
         
          <div id="step1" style={{display:this.props.userState.step === 1 ? 'inline': 'none'}}>
            <h2 style={{color:'white', marginTop:'15px'}}> {strings.bookCarOnline}
            </h2>
            <Form onSubmit={this.handleSubmit} style={{color:'white', marginTop:'15px'}} > 
                <FormItem 
                label={strings.phone}
                >
                  <Input
                    {...getFieldProps('phone', {
                      rules: { required: true, message: strings.pleaseInputYourPhone },
                    })}
                    placeholder={strings.enterPhone}
                    prefix={<Icon type="phone" style={{ fontSize: 13 }} />}
                  />
                </FormItem>
                <FormItem label={strings.name}>
                  <Input
                    {...getFieldProps('name', {
                      rules: { required: true, message: strings.pleaseInputYourName },
                    })}
                    placeholder={strings.enterName}
                    prefix={<Icon type="user" style={{ fontSize: 13 }} />}
                  />
                </FormItem>
                <FormItem label={strings.from}>
                    <Geosuggest
                      {...getFieldProps('start', {
                        rules: { required: true, message: strings.pleaseInputStartPoint },
                      })}
                      placeholder={strings.enterFrom}
                      inputClassName="ant-input ant-input-lg"
                      country="vn"
                      onSuggestSelect={this.onSuggestSelectFrom}
                    />
                </FormItem>
                
                <FormItem label={strings.to} >
                    <Geosuggest
                      {...getFieldProps('end', {
                        rules: { required: true, message: strings.pleaseInputEndPoint },
                      })}
                      placeholder={strings.enterTo}
                      inputClassName="ant-input ant-input-lg"
                      country="vn"
                      onSuggestSelect={this.onSuggestSelectTo}
                    />
                </FormItem>
                      {timeTag}
             
              <Button type="primary" htmlType="submit" style = {{ marginBottom: '20px'}} >{strings.next}<Icon type="right" /></Button>
            </Form>
          </div>
          <div id="step2" style={{display:this.props.userState.step === 2 ? 'inline': 'none'}}>
            <h2 style={{color:'white', marginTop:'15px'}}> {strings.selectCar}
            </h2>
            <CheckboxGroup onChange={this.onChangeCheckBox} value={this.props.appState.checkData}>
              {tmpTabItem}            
            </CheckboxGroup>            
            <div style={{textAlign: 'left', marginTop:'20px'}}>
                <h3  style={{ color: 'white'}}> {strings.price}: { this.props.appState.price.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                }) } VNĐ </h3>
                <h4 style={{ color: 'white'}}> Giá trên chưa bao gồm phí cầu đường </h4>
            </div>
            <Row style={{marginTop:'20px'}}>
              <Button.Group size='large'>
                <Button type="primary" onClick={()=>{
                  // this.setState({step:1, checkData: []});
                  this.props.appState.setAppState('checkData',[]);                  
                  this.props.userState.preStep();
                }}>
                  <Icon type="left" />{strings.back}
                </Button>
                <Button type="primary" onClick={()=>{
                  if( this.props.appState.checkData.length > 0)
                    this.props.userState.nextStep();
                }}>
                {strings.next}<Icon type="right" />
                </Button>
              </Button.Group>
            </Row>
          </div>
          <div id="step3" style={{textAlign: 'left', color:'white', display:this.props.userState.step === 3 ? 'inline': 'none'}}>
            <h2 style={{color:'white', marginTop:'15px', textAlign: 'center'}}> {strings.confirmInfomation}
            </h2>
            <Row>
              <Col span={8}> {strings.time}: 
              </Col>
              <Col span={12}>
                      {moment.unix(this.props.appState.time).format('HH:mm - DD/MM/YYYY')}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.price}:
              </Col>
              <Col span={12}>
                      {this.props.appState.price.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                      })} VNĐ
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.typeOfService}:
              </Col>
              <Col span={12}>
                      {fareSelected? fareSelected.name: ''}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.name}:
              </Col>
              <Col span={12}>
                {this.props.appState.name}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.phone}:
              </Col>
              <Col span={12}>
                {this.props.appState.phone}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.from}:
              </Col>
              <Col span={12}>
                {this.props.appState.start.address}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.to}:
              </Col>
              <Col span={12}>
                {this.props.appState.end.address}
              </Col>
            </Row>
            <Row style={{marginTop:'20px', textAlign: 'center'}}>
              <Button.Group size='large'>
                <Button type="primary" onClick={()=>{
                  // this.setState({step:2});
                  this.props.userState.preStep();
                }}>
                  <Icon type="left" />{strings.back}
                </Button>
                <Button type="primary" onClick={()=>{
                  if(this.props.userState.sessionkey === ''){
                    this.smsLogin()                    
                  } else{
                    const {appState} = this.props;
                    if(this.props.appState.phone === this.props.userState.userInfo.phone){
                      const tmp = appState.checkData[0].split('_');
                      const fare = appState.serviceGroup[tmp[0]].fare_profile_lines[tmp[1]];
                      const sessionkey = this.props.userState.userInfo.sessionkey
                      const distance = appState.distance;
                      const dropoff_time = {
                        'end_time':appState.time + appState.duration*60,
                        'start_time':appState.time - 1800 + appState.duration*60,
                        };
                      const fareid = fare.fpid; 
                      const start = {
                        'address':appState.start.address,
                        'area':'',
                        'compact_address':'',
                        'lat':appState.start.lat,
                        'lng':appState.start.lng
                        };
                        const from_area = fare.pickup_id;
                        const isReturn = false;
                        const is_sharing = false;
                        const load = 1;
                        const note = '';
                        const operator_id = 0;
                        const pickup_time =  {
                          'end_time':appState.time ,
                          'start_time':appState.time - 1800,
                          };
                          const price_range = {
                            'higher_cost':appState.price,
                            'lower_cost':appState.price
                            };
                          const return_distance = 0;
                          const return_range = {
                            'higher_cost':0,
                            'lower_cost':0
                            };
                          const return_rate = 0;
                          const return_time = {
                            'end_time':0,
                            'start_time':0
                            };
                          const route = [{
                            'arrive_time':{
                            'end_time':0,
                            'start_time':0
                            },
                            'location':{
                            'address':appState.start.address,
                            'area':'',
                            'compact_address':'',
                            'lat':appState.start.lat,
                            'lng':appState.start.lng
                            },
                            'request_id':0,
                            'stop_type':1
                            },{
                              'arrive_time':{
                              'end_time':0,
                              'start_time':0
                              },
                              'location':{
                              'address':appState.end.address,
                              'area':'',
                              'compact_address':'',
                              'lat':appState.end.lat,
                              'lng':appState.end.lng
                              },
                              'request_id':0,
                              'stop_type':2
                              }];
                              const  service_group_id = fare.service_group_id;
                              const status = 0;
                              const end = {
                                'address':appState.end.address,
                                'area':'',
                                'compact_address':'',
                                'lat':appState.end.lat,
                                'lng':appState.end.lng
                                };
                              const to_area = fare.dropoff_id;
                              const vehicle_capacity = fare.vehicle_capacity;
                              const vehicle_quality = fare.vehicle_class;
                              const vehicle_type = fare.vehicle_type;
                      this.props.userState.bookCar(sessionkey, distance, dropoff_time, fareid, start, from_area, isReturn, is_sharing, load, note, operator_id, pickup_time, price_range, return_distance, return_range, return_rate, return_time, route, service_group_id, status, end, to_area, vehicle_capacity, vehicle_quality, vehicle_type);
                    } else{
                      this.smsLogin()                                          
                    }
                  }
                }}>
                {strings.booking}<Icon type="right" />
                </Button>
              </Button.Group>
            </Row>
          </div>
          <div id="step4" style={{textAlign: 'left', color:'white', display:this.props.userState.step === 4 ? 'inline': 'none'}}>
            <h2 style={{color:'white', marginTop:'15px', textAlign: 'center'}}> {strings.bookingCarSuccess}
            </h2>
            <Row>
              <Col span={8}> {strings.time}: 
              </Col>
              <Col span={12}>
                      {moment.unix(this.props.appState.time).format('HH:mm - DD/MM/YYYY')}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.price}:
              </Col>
              <Col span={12}>
                      {this.props.appState.price.toLocaleString(undefined, {
                        minimumFractionDigits: 0,
                      })} VNĐ
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.typeOfService}:
              </Col>
              <Col span={12}>
                      {fareSelected? fareSelected.name: ''}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.name}:
              </Col>
              <Col span={12}>
                {this.props.appState.name}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.phone}:
              </Col>
              <Col span={12}>
                {this.props.appState.phone}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.from}:
              </Col>
              <Col span={12}>
                {this.props.appState.start.address}
              </Col>
            </Row>
            <Row>
              <Col span={8}> {strings.to}:
              </Col>
              <Col span={12}>
                {this.props.appState.end.address}
              </Col>
            </Row>
            <br />
            <Row style={{textAlign: 'left'}}>
              Chú ý: Tài xế sẽ liên hệ với bạn ngay sau khi nhận chuyến.
              <br />
              Cài đặt ứng dụng để cập nhật trạng thái của chuyến đi
            </Row>

            <Row style={{marginTop:'20px', textAlign: 'center'}}>
            <Button type="primary" onClick={()=>{
              this.props.userState.setUserState('step', 1);
                window.location.reload();
              }
              }>
            {strings.makeNewRequest}<Icon type="right" />
            </Button>
            </Row>
          </div>
         </div>
         <a href="https://123xe.vn/app" style={{color: '#108ee9', textDecoration: 'underline'	}}>{strings.dowloadTitle}</a>
         <Row>
          <Select defaultValue="vi" style={{ width: 120 , marginTop: '10px'}}  onChange={this.handleChangeLanguage} >
            <Option value="vi">Tiếng Việt</Option>
            <Option value="en">English</Option>
          </Select>
         </Row>
         
      </div>
    );
  }

  handleInc = () => {
    this.props.appState.increment();
  }
  handleDec = () => {
    this.props.appState.decrement();
  }
}
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 14 },
};

const WrappedDemo = createForm({ defaultItemProps: formItemLayout })(App);
export default WrappedDemo;



// WEBPACK FOOTER //
// ./src/App.js